<div class="share-dialog-container">
    <!-- Header -->
    <div class="dialog-header">
        <div class="header-content">
          <div class="upload-icon">
            <!-- <img src="assets/images/cloudadd.svg" alt="Upload"> -->
            <i class="bi bi-person-plus-fill" style="font-size: 30px;color: #0066CC;"></i>
          </div>
          <div class="header-text">
            <h2>Share Document</h2>
            <p>Send a request to start the digital relationship.</p>
          </div>
        </div>
        <button mat-icon-button (click)="onCancel()" class="cancel-btn">
          <img class="close-button" src="assets/images/close-circle.svg" alt="Upload">
        </button>
      </div>
  
    <!-- Document Preview -->
    <div class="document-preview-container">
      <div class="document-preview">
        <ng-container *ngIf="data.document" [ngSwitch]="data.document.mimeType">
          <img *ngSwitchCase="'image/jpeg'" [src]="getDocumentPreviewUrl()" [alt]="data.document.name">
          <img *ngSwitchCase="'image/png'" [src]="getDocumentPreviewUrl()" [alt]="data.document.name">
          <iframe *ngSwitchCase="'application/pdf'" [src]="getDocumentPreviewUrl()" frameborder="0"></iframe>
          <div *ngSwitchDefault class="no-preview">
            <img src="assets/images/docempty.png" alt="document icon" class="docmat">
            <p>Preview not available for this file type</p>
          </div>
        </ng-container>
      </div>
    </div>
  
  <!-- Document Details -->
<!-- Document Details Section - Replace the existing document-details div with this -->
<div class="document-details">
  <p class="shareme">Document Details</p>
  <div class="detail-row">
    <span class="label">Folder</span>
    <span class="value">{{ data.document.tags?.join(', ') || 'N/A' }}</span>
  </div>

  <div class="detail-row">
    <span class="label">Document Name</span>
    <!-- Show doctype for identity documents, name for others -->
    <span class="value" *ngIf="data.category === 'identity'">{{getDoctypeName(data?.document?.doctype) }}</span>
    <span class="value" *ngIf="data.category !== 'identity'">{{data?.document?.name}}</span>
  </div>

  <!-- Conditional field: Document ID for identity, Description for others -->
  <div class="detail-row" *ngIf="data.category === 'identity'">
    <span class="label">Document ID</span>
    <span class="value">{{data.document.docid || 'N/A'}}</span>
  </div>

  <div class="detail-row" *ngIf="data.category !== 'identity'">
    <span class="label">Description</span>
    <span class="value">{{data.document.description || 'N/A'}}</span>
  </div>

  <div class="detail-row">
    <span class="label">Expiration Date</span>
    <span class="value">{{formatDate(data.document.expirationDate)}}</span>
  </div>

  <!-- Tags Section -->
  <div class="detail-row">
    <span class="label">Added Tags</span>
    <div class="tags-container">
      <ng-container *ngIf="data.document.user_tags?.length; else noUserTags">
        <mat-chip-list>
          <mat-chip *ngFor="let userTag of data.document.user_tags" color="accent" selected>
            {{userTag}}
          </mat-chip>
        </mat-chip-list>
      </ng-container>
      <ng-template #noUserTags>
        <span class="value">N/A</span>
      </ng-template>
    </div>
  </div>

  <div class="detail-row">
    <span class="label">Country Affiliation</span>
    <span class="value">{{ data.document?.country }}</span>
  </div>

</div>

  
    <!-- Choose Category Section -->
    <!-- <div class="choose-category">
      <h3>Choose Category</h3>
      <mat-form-field appearance="outline" class="category-select">
        <mat-select [formControl]="selectedCategory" placeholder="Legal">
          <mat-option *ngFor="let category of categories" [value]="category">
            {{category}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
  
    <!-- Search Box -->
    <div class="search-container">
      <p class="shareme">Share with</p>
      <mat-form-field appearance="outline" class="search-field">
        <span matPrefix>
          <i class="bi bi-search"></i>&nbsp;
        </span>
        <input matInput placeholder="Search for connections">
      </mat-form-field>
    </div>

  
     <!-- People List -->
    <div class="people-list">
      <div *ngFor="let person of filteredPeople" class="person-card">
        <div class="avatar-container">
          <!-- Show profile image if available, otherwise show initial with blue background -->
          <img *ngIf="hasValidAvatar(person)" 
               [src]="person.avatar" 
               alt="{{person.name}} avatar" 
               class="avatar-image">
          <div *ngIf="!hasValidAvatar(person)" 
               class="avatar" 
               [style.background-color]="getAvatarColor(person.id)"
               [title]="'No profile image available for ' + person.name">
            {{getInitial(person.name)}}
          </div>
        </div>
        <div class="person-info">
          <div class="person-name">{{person.name}}</div>
          <!-- <div class="person-email">{{person.email}}</div> -->
        </div>
        <mat-checkbox 
          [checked]="person.selected" 
          (change)="toggleSelection(person)" 
          color="primary">
        </mat-checkbox>
      </div>
    </div>
  
    <!-- Action Buttons -->
    <div class="dialog-actions">
      <button mat-button (click)="onCancel()" class="cancel-btn1" >Cancel</button>
      <button mat-flat-button color="primary" class="share-btn"  (click)="onShare()">Next</button>
    </div>
  </div>